(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree41b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree41b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kgd8P", function(module, exports) {

$parcel$export(module.exports, "validateInput", () => $ebff7ee1a9607aef$export$4d09d4ac8ba225dd);
$parcel$export(module.exports, "validateMultiPattern", () => $ebff7ee1a9607aef$export$34cff50e36962659);
$parcel$export(module.exports, "validateMultiSwitch", () => $ebff7ee1a9607aef$export$a2bfd6cfaaba21d1);
$parcel$export(module.exports, "validateMultiRadio", () => $ebff7ee1a9607aef$export$4c31d8ac9e91aaa6);
$parcel$export(module.exports, "validateSwitch", () => $ebff7ee1a9607aef$export$216d5642575b8c06);
$parcel$export(module.exports, "validateSelect", () => $ebff7ee1a9607aef$export$9cd486fd06b2d311);
$parcel$export(module.exports, "validateForm", () => $ebff7ee1a9607aef$export$ed692cabb252e59b);
$parcel$export(module.exports, "resetForm", () => $ebff7ee1a9607aef$export$a2a1e8c320d4e05d);
$parcel$export(module.exports, "lockForm", () => $ebff7ee1a9607aef$export$1c0a3ac618381296);
$parcel$export(module.exports, "unlockForm", () => $ebff7ee1a9607aef$export$99c08c3a9a42f215);

var $613bB = parcelRequire("613bB");

var $kOwRn = parcelRequire("kOwRn");
const $ebff7ee1a9607aef$var$fieldIsRequired = (field)=>{
    return field.classList.contains((0, $kOwRn.classes).required);
};
const $ebff7ee1a9607aef$export$4d09d4ac8ba225dd = (field)=>{
    let fieldIsValid = true;
    const input = field.querySelector('input, textarea');
    // Check if field is empty or invalid
    if (!input.value) {
        // Field is empty
        if ($ebff7ee1a9607aef$var$fieldIsRequired(field)) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        } else (0, $613bB.resetFieldState)(field);
    } else if (!input.checkValidity()) {
        // Field value is invalid
        (0, $613bB.markFieldError)(field, 'invalid');
        fieldIsValid = false;
    } else if (window.blacklist.length && input.type === 'email' && window.blacklist.filter((v)=>input.value.split('@')[1] === v).length > 0) {
        // The entered email is blacklisted
        (0, $613bB.markFieldError)(field, 'blacklisted');
        fieldIsValid = false;
    } else // Field is neither empty nor invalid => Field is valid!
    (0, $613bB.markFieldAsValid)(field);
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$34cff50e36962659 = (field)=>{
    let fieldIsValid = true;
    const input = field.querySelector('input, textarea');
    const patterns = JSON.parse(input.getAttribute((0, $kOwRn.dataAttributes).fieldPattern));
    for(let key in patterns){
        const pattern = patterns[key];
        input.setAttribute('pattern', pattern);
        if (input.value.match(pattern)) (0, $613bB.markFieldAsValid)(field);
        else {
            (0, $613bB.markFieldError)(field, key);
            fieldIsValid = false;
            break;
        }
    }
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$a2bfd6cfaaba21d1 = (field)=>{
    let fieldIsValid = true;
    const switches = field.querySelectorAll('.form-binary-input');
    if (!$ebff7ee1a9607aef$var$fieldIsRequired(field)) // Field is not required
    return fieldIsValid;
    for(let i = 0; i < switches.length; i++){
        const cb = switches[i].querySelector('input');
        if (cb.checked) {
            (0, $613bB.markFieldAsValid)(field);
            break;
        } else if (i === switches.length - 1) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        }
    }
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$4c31d8ac9e91aaa6 = (field)=>{
    let fieldIsValid = true;
    const switches = field.querySelectorAll('.form-binary-input');
    if (!$ebff7ee1a9607aef$var$fieldIsRequired(field)) // Field is not required
    return fieldIsValid;
    for(let i = 0; i < switches.length; i++){
        const cb = switches[i].querySelector('input');
        if (cb.checked) {
            (0, $613bB.markFieldAsValid)(field);
            break;
        } else if (i === switches.length - 1) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        }
    }
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$216d5642575b8c06 = (field)=>{
    let fieldIsValid = true;
    // Only do validity checks if switch has an "off" state
    if (!field.querySelector('.custom-switch-wrapper')) {
        const cb = field.querySelector('input');
        if (!cb.checkValidity() && $ebff7ee1a9607aef$var$fieldIsRequired(field)) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        } else (0, $613bB.markFieldAsValid)(field);
    }
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$9cd486fd06b2d311 = (field)=>{
    let fieldIsValid = true;
    const select = field.querySelector('select');
    if (!select.value) {
        // Select has empty value
        if ($ebff7ee1a9607aef$var$fieldIsRequired(field)) {
            (0, $613bB.markFieldError)(field, 'empty');
            fieldIsValid = false;
        } else (0, $613bB.resetFieldState)(field);
    } else // Select has value
    (0, $613bB.markFieldAsValid)(field);
    return fieldIsValid;
};
const $ebff7ee1a9607aef$export$ed692cabb252e59b = (form, returnFields = false)=>{
    const fields = {};
    // Validate every field in the form
    form.querySelectorAll((0, $kOwRn.selectors).field).forEach((field)=>{
        const fieldType = field.getAttribute((0, $kOwRn.dataAttributes).fieldType);
        const fieldName = field.getAttribute((0, $kOwRn.dataAttributes).fieldName);
        if ([
            'text',
            'textarea',
            'number',
            'email',
            'tel',
            'url',
            'password'
        ].includes(fieldType)) fields[fieldName] = $ebff7ee1a9607aef$export$4d09d4ac8ba225dd(field);
        else if (fieldType === 'switch') fields[fieldName] = $ebff7ee1a9607aef$export$216d5642575b8c06(field);
        else if (fieldType === 'multi_switch') fields[fieldName] = $ebff7ee1a9607aef$export$a2bfd6cfaaba21d1(field);
        else if (fieldType === 'select') fields[fieldName] = $ebff7ee1a9607aef$export$9cd486fd06b2d311(field);
        else if (fieldType === 'radio') fields[fieldName] = $ebff7ee1a9607aef$export$4c31d8ac9e91aaa6(field);
    });
    return returnFields ? fields : !Object.values(fields).includes(false);
};
const $ebff7ee1a9607aef$export$a2a1e8c320d4e05d = (form)=>{
    form.reset();
    form.querySelectorAll((0, $kOwRn.selectors).field).forEach((field)=>{
        (0, $613bB.resetFieldState)(field);
        field.disabled = false;
    });
};
const $ebff7ee1a9607aef$export$1c0a3ac618381296 = (form)=>{
    form.querySelectorAll((0, $kOwRn.selectors).field).forEach((field)=>field.disabled = true);
};
const $ebff7ee1a9607aef$export$99c08c3a9a42f215 = (form)=>{
    form.querySelectorAll((0, $kOwRn.selectors).field).forEach((field)=>field.disabled = false);
};

});
parcelRegister("613bB", function(module, exports) {

$parcel$export(module.exports, "markFieldError", () => $46154ec4936d1277$export$62894790ff73cc21);
$parcel$export(module.exports, "markFieldAsValid", () => $46154ec4936d1277$export$8c1ebd23297ed672);
$parcel$export(module.exports, "resetFieldState", () => $46154ec4936d1277$export$8d5aa774dee7db0);

var $kOwRn = parcelRequire("kOwRn");
const $46154ec4936d1277$var$activeErrorClass = 'active';
const $46154ec4936d1277$var$resetFieldErrors = (field)=>{
    field.classList.remove((0, $kOwRn.classes).error);
    field.querySelectorAll((0, $kOwRn.selectors).fieldError).forEach((errorMessage)=>{
        errorMessage.classList.remove($46154ec4936d1277$var$activeErrorClass);
    });
};
const $46154ec4936d1277$export$62894790ff73cc21 = (field, error)=>{
    $46154ec4936d1277$var$resetFieldValid(field);
    $46154ec4936d1277$var$resetFieldErrors(field);
    // Add error class
    field.classList.add((0, $kOwRn.classes).error);
    // Show individual error icon
    field.querySelector(`${(0, $kOwRn.selectors).fieldError}--${error}`).classList.add($46154ec4936d1277$var$activeErrorClass);
};
const $46154ec4936d1277$var$resetFieldValid = (field)=>{
    field.classList.remove((0, $kOwRn.classes).valid);
};
const $46154ec4936d1277$export$8c1ebd23297ed672 = (field)=>{
    $46154ec4936d1277$var$resetFieldErrors(field);
    field.classList.add((0, $kOwRn.classes).valid);
};
const $46154ec4936d1277$export$8d5aa774dee7db0 = (field)=>{
    $46154ec4936d1277$var$resetFieldErrors(field);
    $46154ec4936d1277$var$resetFieldValid(field);
};

});
parcelRegister("kOwRn", function(module, exports) {

$parcel$export(module.exports, "selectors", () => $f271f776916c2f5b$export$e1252723db1c541);
$parcel$export(module.exports, "classes", () => $f271f776916c2f5b$export$188d75d71883854a);
$parcel$export(module.exports, "dataAttributes", () => $f271f776916c2f5b$export$15d6ddc168d35719);
const $f271f776916c2f5b$export$e1252723db1c541 = {
    field: 'div.form-field',
    fieldError: '.field-error'
};
const $f271f776916c2f5b$export$188d75d71883854a = {
    valid: 'form-field--valid',
    error: 'form-field--error',
    required: 'form-field--required'
};
const $f271f776916c2f5b$export$15d6ddc168d35719 = {
    fieldType: 'data-field-type',
    fieldName: 'data-field-name',
    fieldError: 'data-field-error',
    fieldPattern: 'data-pattern'
};

});




var $kgd8P = parcelRequire("kgd8P");
const $40bed61a4f0a8149$var$emailTrialForms = document.querySelectorAll('.mp-email-trial-form');
$40bed61a4f0a8149$var$emailTrialForms.forEach((form)=>{
    form.addEventListener('submit', (event)=>{
        event.preventDefault();
        if (!(0, $kgd8P.validateForm)(form)) // Stop propagation if the form is not valid
        // * This way Google Tag Manager's listener won't receive the bubbling submit event
        event.stopPropagation();
        else window.location.assign(`${form.getAttribute('action')}?email=${form.querySelector('input[type="email"]').value}`);
    });
});

})();
//# sourceMappingURL=trial.min.js.map
